import React from "react";
import PropTypes from "prop-types";

import DateFormatter from "services/DateFormatingService";

import "../avatar.scss";
import "../comment.scss";

const CommentItem = ({ name, city, timestamp, comment, emoticon }) => (
  <div className="comment">
    <span className={`comment__image avatar avatar--${emoticon}`} />
    <div className="comment__content">
      <div className="comment__heading">
        <div className="comment__meta">
          <div className="comment__author">
            <span className="comment__name">{name}</span>&nbsp;uit {city}
          </div>
          <div className="comment__date">
            {DateFormatter.formatToTimeAndDate(timestamp * 1000)}
          </div>
        </div>
      </div>
      <div className="comment__text">{comment}</div>
    </div>
  </div>
);

CommentItem.propTypes = {
  name: PropTypes.string.isRequired,
  city: PropTypes.string.isRequired,
  timestamp: PropTypes.string.isRequired,
  comment: PropTypes.string.isRequired,
  emoticon: PropTypes.string.isRequired,
};

export default CommentItem;
